import useConfigStore from "../stores/useConfigStore";

export const getPricingRules = () => useConfigStore.getState().pricingRules || [];

export const findPricingRuleById = (id) => {
  if (!id) return [];
  const lower = id.toLowerCase();
  return getPricingRules().filter(
    (r) => (r.mPricingrulesId || "").toLowerCase() === lower
  );
};
